import { MrfiktivParsedMimeMailAddressViewmodelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import {
  IMessageHeadersParsedMimeMailAddressValue,
  MessageHeadersParsedMimeMailAddressValue
} from "./message-headers-parsed-mime-mail-address-value.entity";

@IsFilterable
export class MessageHeadersParsedMimeMailAddressBase implements MrfiktivParsedMimeMailAddressViewmodelGen {
  @FilterConfig({ type: MessageHeadersParsedMimeMailAddressValue })
  value: IMessageHeadersParsedMimeMailAddressValue[];

  /**
   * Has HTML representation of the addresses with to-anchors opening mail client.
   */
  @FilterConfig({ type: FilterTypes.STRING })
  html: string;

  /**
   * @example 'Nils Pulte' <nils.pulte@mmmint.ai>; 'Mils Pulte' <mils.pulte@mmmint.ai>; ...
   */
  @FilterConfig({ type: FilterTypes.STRING })
  text: string;

  /**
   * Returns list of messages with names if available.
   * @example Nils Pulte <nils.pulte@mmmint.ai>; Mils Pulte <mils.pulte@mmmint.ai>; no.name@mail.com; ...
   * Similar to 'text' but the name is in quotes in the text representation
   */
  get readable(): string {
    return this.value.map(v => v.readable).join("; ");
  }

  constructor(src?: Partial<IMessageHeadersParsedMimeMailAddress | MrfiktivParsedMimeMailAddressViewmodelGen>) {
    this.value = (src?.value || []).map(v => new MessageHeadersParsedMimeMailAddressValue(v));
    this.html = src?.html || "";
    this.text = src?.text || "";
  }
}
type IMessageHeadersParsedMimeMailAddress = MessageHeadersParsedMimeMailAddressBase;
const MessageHeadersParsedMimeMailAddress = Filter.createForClass(MessageHeadersParsedMimeMailAddressBase);
export { IMessageHeadersParsedMimeMailAddress, MessageHeadersParsedMimeMailAddress };
